<template>
  <div id="carousel">
    <carousel :items-to-show="1.5" :wrap-around="true" :breakpoints="breakpoints">
      <slide v-for="(slide, index) in content" :key="index">
        <div class="carousel__item">
          <card
            clickable="true"
            :id="slide.category + '-card-' + (index + 1)"
            :category="slide.category"
            :value="slide.value"
            @radio-selected="removeAll([$event, slide.category]); showFormOnOther();"
            :output="slide.alt">
            
            <sb-image :src="slide.img" :alt="slide.alt"></sb-image>
          </card>
        </div>
      </slide>

      <template #addons>
        <navigation />
        <pagination />
      </template>
    </carousel>
    <label v-show="formVisible" for="otherInput">Please enter your industry below:</label>
    <input v-show="formVisible" type="text" name="otherInput" id="otherInput" v-model="$store.state.selectedValues.industry">
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

import Card from '../Card.vue';
import SbImage from '../SbImage/SbImage.vue';
import { Carousel, Slide, Navigation, Pagination } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';


export default {
  name: 'RadioCarousel',
  components: {
    Carousel,
    Slide,
    Navigation,
    Pagination,
    Card,
    SbImage,
  },
  props: ['content', 'store'],
  data() {
    return {
      step: 0,
      cards: 10,
      breakpoints: {
        576: {
          itemsToShow: 2.25
        },
        768: {
          itemsToShow: 3.25
        }
      },
      formVisible: false,
      industries: ["Healthcare", "Higher Education", "Insurance", "Financial Services", "Government", "Manufacturing"],
    }
  },
  methods: {
    ...mapMutations([
      'removeAll',
    ]),
    showFormOnOther() {
      if (this.industries.includes(this.$store.state.selectedValues.industry) || this.store !== 'industries') {
        this.formVisible = false;
      } else if (this.$store.state.selectedValues.industry === '') {
        this.formVisible = true
      } else {
        this.formVisible = true;
        this.$store.state.selectedValues.industry = '';
      }
    },
  },
  mounted() {
    if (this.industries.includes(this.$store.state.selectedValues.industry) || this.store !== 'industries') {
      this.formVisible = false;
    } else if (this.$store.state.selectedValues.industry === '') {
      this.formVisible = false
    } else {
      this.formVisible = true
      this.$store.state.selectedValues.industry = '';
    }
  },
}
</script>

<style scoped>
  #carousel {
    padding: 13px;
  }

  .card {
    width: 100%;
    background-color: #efefef;
    border: 4px solid transparent;
    transition: border 0.5s ease;
  }

  .carousel {
    overflow: visible;
  }

  .carousel__pagination-item {
    padding-left: 0 !important;
  }

  .carousel__pagination {
    list-style: none !important;
  }

  .carousel__item {
    width: 90%;
  }

  .carousel__slide > .carousel__item {
    transform: scale(1);
    opacity: 0.5;
    transition: 0.5s;
  }
  .carousel__slide--visible > .carousel__item {
    opacity: 1;
  }
  .carousel__slide--next > .carousel__item {
    transform: scale(0.9) translate(-10px);
  }
  .carousel__slide--prev > .carousel__item {
    transform: scale(0.9) translate(10px);
  }
  .carousel__slide--active > .carousel__item {
    transform: scale(1.1);
  }

  input,
  label {
    margin: 0.25rem 0;
    max-width: 400px;
    display: block;
  }
</style>